module.exports = __webpack_public_path__ + "img/istoe-dinheiro.svg";